module.exports = __webpack_public_path__ + "img/electricity.b7ad8e3.svg";